import { defineStore } from 'pinia';
import { useUserStore } from '@/stores/user.store.js';
import { useAccountStore } from '@/stores/account.store.js';
import { useWorkspaceStore } from '@/stores/workspace.store.js';
import { GET_CURRENT_USER_QUERY } from '@/services/user/queries/index.js';
import { API } from '@/services/index.js';
import { GET_ACCOUNTS_QUERY } from '@/services/account/queries/account/index.js';
import router from '@/router/index.js';
import slugify from 'slugify';

export const useAppStore = defineStore({
  id: 'app',
  state: () => ({
    isAppLoading: false,
    socialChannelTypes: [],
    errors: null
  }),
  getters: {},
  actions: {
    async init() {
      try {
        this.isAppLoading = true;
        const [account, user] = await Promise.all([
          API.sendQuery('/graphql/account', GET_ACCOUNTS_QUERY),
          API.sendQuery('/graphql/user', GET_CURRENT_USER_QUERY)
        ]);

        if (account.data.data.accounts && account.data.data.accounts.length > 0) {
          useAccountStore().setAccounts(account.data.data.accounts);
        }

        if (user.data.data.userPreferences && user.data.data.userPreferences.length > 0) {
          useUserStore().preferences = user.data.data.userPreferences;
        }

        if (user.data.data.currentUser) {
          useUserStore().updateCurrentUser(user.data.data.currentUser);
        }

        // set initial active account if exists in user preferences
        this.setInitialActiveAccount(user.data.data.userPreferences);

        // now that we have user preferences & accounts, fetch workspaces
        await useWorkspaceStore().getWorkspaces({ archived: false, account_id: useAccountStore().activeAccount.id });

        return true;
      } catch (e) {
        console.log(e);
        this.isAppLoading = false;
      } finally {
        this.isAppLoading = false;
      }
    },

    setInitialActiveAccount(userPreferences) {
      const activeAccount = userPreferences.find((pref) => pref.key === 'active_account');
      if (activeAccount && activeAccount.value && useAccountStore().accounts.some((acc) => acc.id === JSON.parse(activeAccount.value).id)) {
        useAccountStore().activeAccount = useAccountStore().accounts.find((acc) => acc.id === JSON.parse(activeAccount.value).id);
      } else {
        // set first account as active if none found in user preferences
        useAccountStore().activeAccount = useAccountStore().accounts[0];
      }
    }

    // setInitialActiveWorkspace(userPreferences) {
    //   const activeWorkspace = userPreferences.find((pref) => pref.key === 'active_workspace');
    //   if (activeWorkspace && activeWorkspace.value && useWorkspaceStore().workspaces.some((ws) => ws.id === JSON.parse(activeWorkspace.value).id)) {
    //     useWorkspaceStore().activeWorkspace = useWorkspaceStore().workspaces.find((ws) => ws.id === JSON.parse(activeWorkspace.value).id);
    //     // router.replace(`/workspace/${useWorkspaceStore().activeWorkspace.id}/${slugify(useWorkspaceStore().activeWorkspace.name, { lower: true })}`);
    //   } else {
    //     // if none found in user preferences or if it doesn't exist in workspaces
    //     useWorkspaceStore().activeWorkspace = null;
    //   }
    // }
  }
});
